/*
 * @Descripttion: 折线图默认的配置选项
 * @Author: zhanghang
 * @Date: 2021-07-21 15:00:22
 * @LastEditors: zhanghang
 * @LastEditTime: 2022-10-18 18:18:40
 */
import common from "./common"
export default dsf.mix(true, {
  //x 轴配置
  xAxis: [{
    type: 'value' ,
    scale: true,
    // 坐标轴线设置
    axisLine: {
      show: true,
      lineStyle:{
        color:'#333'
      }
    },
    // 坐标刻度设置
    axisTick: {
      show: true,
      //刻度对齐数据系
      alignWithLabel:false,
    },
    // 坐标标签设置
    axisLabel: {
      show: true,
      fontSize:12,
      rotate:0,
      color:'#333'
  
    },
    //分割线设置
    splitLine: {
      show: true
    },
    //坐标轴名字
    name:'坐标轴名称',
    // 坐标轴名字位置
    nameLocation:'center',
    nameTextStyle:{
      color:'#333',
      fontSize:12
    },
    //名字与轴线距离
    nameGap: 30 ,
    //两边留白策略
    boundaryGap: true,
    //坐标轴位置
    position:'bottom',
    interval:1,
  }],
  yAxis: [{
    type: 'value' ,
    scale: true,
    // 坐标轴线设置
    axisLine: {
      show: true,
      lineStyle:{
        color:'#333'
      }
    },
    // 坐标刻度设置
    axisTick: {
      show: true
    },
    // 坐标标签设置
    axisLabel: {
      show: true,
      fontSize:12,
      rotate:0,
      color:'#333'
    },
    //分割线设置
    splitLine: {
      show: true
    },
    //坐标轴名字
    name:'坐标轴名称',
    // 坐标轴名字位置
    nameLocation:'end',
    nameTextStyle:{
      color:'#333',
      fontSize:12
    },
    //名字与轴线距离
    nameGap: 18 ,
    //坐标轴位置
    position:'left',
  }],
  //数据系配置
  series: [{
    type:'scatter',
    name:'示例',
    //对应x轴下标
    yAxisIndex:0,
    //对应y轴下标
    xAxisIndex:0,
    // 标记图形
    symbol:'circle',
    //标记大小
    symbolSize:20,

    //标签是否展示
    label:{
      show:false
    },

    // 散点样式
    itemStyle:{
      color:common.color[0],
      endColor:common.color[0],
      startColor:common.color[0],
      isshade:false
    },
 
    //数据
    data:[{
      name:'测试1',
      value:[10.0, 8.04]
    },{
      name:'测试2',
      value:[8.0, 6.95]
    },{
      name:'测试3',
      value:[13.0, 7.58]
    },{
      name:'测试4',
      value:[9.0, 8.81]
    },{
      name:'测试5',
      value:[11.0, 8.33]
    }],
  }],
  //提示配置
  tooltip: {
    trigger: 'item' ,
  },
}, common); 